<template lang="pug">
  .dashboard-inner.narrow-modal-body
    SectionTitle(:text="modalTitle" data-mr-ass="edit-sub-address").app-modal-title
    form(@submit.prevent="onSubmit")
      .row
        AddressEditInputs(:v="$v")

      .row
        SubmitButtons(
          submit-text="Save"
          :submit-method="onSubmit"
          :submit-disabled="savingAddress"
          cancel-text="Cancel"
          :cancel-method="hideModal"
        )
  
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import AddressEditInputs from './AddressEditInputs';
  import SubmitButtons from "../SubmitButtons";
  import SectionTitle from "../SectionTitle";

  export default {
    name: "AddressEditModal",
    components: {
      SectionTitle,
      AddressEditInputs,
      SubmitButtons
    },

    computed: {
      ...mapState('modal', ['visible']),
      ...mapState('addressBook', [
        'editAddressForm',
        'savingAddress',
        'addressFormValidators'
      ]),

      modalTitle() {
        return `${this.editAddressForm.id ? 'Edit' : 'Add'} Address`;
      }
    },

    methods: {
      ...mapActions('addressBook', [
        'saveAddressForm',
        'clearEditAddressForm'
      ]),

      ...mapActions('modal', ['hideModal']),

      onSubmit() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.saveAddressForm().then(() => this.hideModal());
      }
    },

    validations() {
      return {
        editAddressForm: this.addressFormValidators
      }
    },

    beforeDestroy() {
      //- if address validation fails we keep the modal visible and insert another component to confirm
      //- the address while keeping the state of the entered address for comparison
      if (!this.visible) {
        this.clearEditAddressForm();
      }
    }
  }
</script>

<style lang="stylus">
  .modal-body
    overflow hidden

  .mr-dropdown
    .customDropdown
      .option
        &.expanded
          max-height 12em

  .address-edit-form
    margin-bottom 2em

</style>
